import {anyTaskHasNovaConversation} from '../../../shared/components/nova-invocation/novaColumnPresence';
// Replace with generated Relay type when My Work is converted to TS
type TaskNode = {
	node?: {
		assignedPersons?: ReadonlyArray<{
			id?: string;
		}>;
		hasNovaConversation?: boolean | null;
	};
};

export function taskAssignedToSelectedPersonPredicate(task: TaskNode, selectedPersonId: string): boolean {
	return !!task?.node?.assignedPersons?.map(assignedPerson => assignedPerson?.id)?.includes(selectedPersonId);
}

/**
 * Whether My Tasks draws its Nova column. One answer for every list on the page, including the
 * overdue list that runs its own query and reports in whether it holds an answer.
 *
 * Somebody who can act gets it whenever they have not turned it off. Somebody who cannot gets it
 * only where one of their tasks, in any list, has an answer to read - and the scan is skipped
 * entirely for those who can act.
 */
export function shouldShowMyTasksNovaColumn(input: {
	novaEnabled: boolean;
	columnPreference: boolean | undefined;
	canActOnTasks: () => boolean;
	tasks: ReadonlyArray<TaskNode>;
	selectedPersonId: string;
	overdueHasNovaAnswer: boolean;
}): boolean {
	if (!input.novaEnabled || input.columnPreference === false) return false;
	if (input.canActOnTasks() || input.overdueHasNovaAnswer) return true;
	return anyTaskHasNovaConversation(
		input.tasks.filter(task => taskAssignedToSelectedPersonPredicate(task, input.selectedPersonId))
	);
}
